import React from 'react';

import { parseEntities } from 'parse-entities';

interface Props {
  containerClass?: string;
  titleClass?: string;
  leftClass?: string;
  rightClass?: string;
  leftContent: React.ReactElement;
  leftTitle?: string;
  rightContent: React.ReactElement;
  rightTitle?: string;
  contentLink?: React.ReactElement;
}

export const TwoColumnsGrid = ({
  leftContent,
  rightContent,
  leftClass = '',
  titleClass = '',
  leftTitle = '',
  rightTitle = '',
  rightClass = '',
  contentLink,
  containerClass = '',
}: Props) => (
  <div className={`main-grid two-columns-grid ${containerClass}`}>
    <div className={`main-grid-item ${leftClass}`}>
      {leftTitle && <h4 className={`title  ${titleClass}`}>{parseEntities(leftTitle)}</h4>}
      {leftContent}
    </div>
    <div className={`main-grid-item ${rightClass}`}>
      {rightTitle && <h4 className={`title  ${titleClass}`}>{parseEntities(rightTitle)}</h4>}
      {rightContent}
    </div>
    {contentLink}
    {contentLink && <div className="device-only">{contentLink}</div>}
  </div>
);
